import { PPProduct } from 'shared'

export const ADMIN_STATE_VERSION = 'admin:1'

export interface AdminState {
  impersonate?: {
    userId: string
    name: string
    token: string
    productInfo?: PPProduct
  }
}

export function initialState(): AdminState {
  return {
    impersonate: undefined
  }
}
